import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cache-refresh-next",
  "use": "icon-cache-refresh-next-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-cache-refresh-next\"><path fill-rule=\"evenodd\" d=\"M23.2.2 28 5l-4.6 4.6L22 8.2 24.2 6H16C10.4 6 6 10.4 6 16s4.4 10 10 10 10-4.4 10-10c0-1-.2-1.8-.4-2.6l1.6-1.6c.6 1.2.8 2.8.8 4.2 0 6.6-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4h8.2l-2.4-2.4zM17 9v7.6l3.8 3.6-1.6 1.6-4.2-4.4V9z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol